import { COLUMN_SIZE } from 'components/common/DataGridDevEx/DataGrid.constants';
const FIELD_COLUMN_WIDTH = 420;

export const columns = [
    {
        dataField: 'Code',
        visible: false,
    },
    {
        dataField: 'Display',
        caption: 'Action',
        minWidth: COLUMN_SIZE.md0,
        width: FIELD_COLUMN_WIDTH,
        allowSorting: false,
    },

];
